import{__require as r}from"./function-uncurry-this.js";import{__require as t}from"./to-object.js";var e,n;function o(){if(n)return e;n=1;var o=r(),u=t(),i=o({}.hasOwnProperty);return e=Object.hasOwn||function(r,t){return i(u(r),t)}}export{o as __require};
//# sourceMappingURL=has-own-property.js.map
